import MypageContainer from "../../components/mypage/MyPageContainer";
import MyPageContent from "../../components/mypage/MyPageContent";
import MyPageHeader from "../../components/mypage/MyPageHeader";
import MypageMenu from "../../components/mypage/MyPageMenu";
import styles from './MypageChat.module.css'; // CSS Modules 파일 import
import React, {useContext,useRef, useState, useEffect } from 'react';
import axios from 'axios';
import {useParams, useNavigate} from 'react-router-dom';
import EmojiPicker from 'emoji-picker-react'; //이모지 emoji
import { MyPageContext } from "../../components/mypage/MyPageContext";
import io from 'socket.io-client';
import {formatDate , formatPhone} from '../../middlewares/formatDate';


const MypageChat = () => {
    const navigate = useNavigate();

    //유저 아이디
    const { id } = useParams();
    
    //유저 정보
    const { data } = useContext(MyPageContext);
    
    //우측 정보 : 회원에 관한 정보
    //1. 내 정보도 볼 수 있게 하면 좋을 것 같다.
    const [rightData, setRightData] = useState({
        userPhone:(data.userData)? data.userData.userPhone : null,
        userEmail:(data.userData)? data.userData.userEmail : null,
        userName:(data.userData)? data.userData.userName : null,
        userCompany:(data.userData)? data.userData.userCompany : null,
        userGrade:(data.userData)? data.userData.userGrade : null,
        userProfile:(data.userData)? data.userData.userProfile : null,
    });

    //우측 정봉 : 이용중인 서비스
    const [serviceData, setServiceData] = useState();

    //채팅 스크롤을 위한 Ref
    const chatScrollRef = useRef(null);

    //전화번호 형식 바꾸기
    let formattedPhone = formatPhone(rightData.userPhone);

    //소켓 전체 인원수 초기값
    //현재 방에 참가 인원
    const [totalPeople, setTotalPeople] = useState(1);
    //소켓 연결
    const [socket, setSocket] = useState(null);
    //메세지 세팅
    const [messages, setMessages] = useState([]);
    const [profile, setProfile] = useState([]);
    //오늘을 기준으로 지난 데이터를 가져오기 위한 숫자
    const [getDataNumber, setGetDataNumber] = useState(0);
    //지난 메세지
    const [exMessages, setExMessages] = useState([]);
    //지난 데이터
    const [exdata, setExdata] = useState(false);
    //참여자
    const [allowParticipants, setAllowParticipants] = useState([]);
    const [Participants, setParticipants] = useState();


    // 프로필
    const [profileView, setProfileView] = useState(false); 
    const [listStatus, setListStatus] = useState(false);
    const [memberStatus, setMemberStatus] = useState(false);
    const [chatStatus, setchatTxt] = useState('');
    const [emojiPopup , setEmojiPopup] = useState(false);
    const memberPopupRef = useRef();
    const [formFile, setFormFile] = useState();
    const profileViewHideHandler = () => { setProfileView(false); }
    const listHandler = () => { setListStatus(!listStatus); }
    const memberPopupHandler = () => { setMemberStatus(!memberStatus); }
    const EmojiPopupHandler = () => { setEmojiPopup(!emojiPopup); }
    const chatHandler = (e) => {
        e.preventDefault();
        setchatTxt(e.target.value);
    }
    //채팅을 이용하기 위한 기초 세팅 

    
 
    
    //소켓연결하기
    useEffect(() => {
        const socket = io(`${process.env.REACT_APP_SERVER_URL}`, {
            path: '/socket.io', // 서버 path와 일치시켜준다
            transports: ['websocket']
        }); // 백서버의 URL을 여기에 입력합니다.
        setSocket(socket);
        //socket 함수
        function check(nick_check,max_check){
            if(nick_check){
                alert("중복 로그인이 감지되었습니다.");
                const redirectURL = `/mypage`; // 리디렉션할 URL 생성
                navigate(redirectURL);
            }
            if(max_check){
                alert('정원이 초과되었습니다.');
                const redirectURL = `/mypage`; // 리디렉션할 URL 생성
                navigate(redirectURL);
            }else{
                //중복과 인원체크하고나서 데이터베이스에 방정보 없으면 만들고 있으면 추가하기
                socket.emit("dbcheck", id,data.userData.userEmail,data.userData.id,check);
            }
        }

        //중복체크,방인원초과체크 
        if(data.userData!=null){
            socket.emit("check", id,data.userData.userEmail,check);
        }




        // 백서버로부터 메시지 수신
        socket.on('msg', (msg) => {
            if (msg.chatRoom == id) {
                setMessages((prevMessages) => [
                    ...prevMessages,
                msg
            ]);
            // const scrollContainer = chatScrollRef.current;
            // scrollContainer.scrollTop = scrollContainer.scrollHeight;
        }
        });


        //소켓에서 다시체크
        socket.on('notallow', () => {
            if(data.userData.userAdmin!=1){
            alert('허용되지 않은 참가자입니다.')
            const redirectURL = `/mypage`; // 리디렉션할 URL 생성
            navigate(redirectURL);
            }
        });

        socket.on('allow', () => {
            socket.emit("enter_room", id, data.userData );
        });

        socket.on('invite', (people,userName) => {
            setTotalPeople(people+1);
            alert(`${userName}님이 초대되었습니다.`)
        });

        socket.on ("exit",async (serverId,users,count,userName)=>{
            setParticipants(users);
            if(data.userData.userName!=userName){
                alert(`${userName}님이 퇴장하였습니다.`)
            }

        });
        socket.on ("entry", (count,users,userName)=>{
            setParticipants(users);
            if(data.userData.userName!=userName){
            alert(`${userName}님이 입장하였습니다.`)
            }
        });

        socket.on ("kick", (userEmail,users,people)=>{
            setParticipants(users);
            setTotalPeople(people-1);
            if(data.userData.userEmail==userEmail){
                alert(`방에서 강퇴당했습니다.`);
                const redirectURL = `/mypage`; // 리디렉션할 URL 생성
                navigate(redirectURL);
            }else{
                alert(`${userEmail}님이 강퇴당했습니다.`)
            }
        });

        return() => {
            // 컴포넌트 언마운트 시 소켓 연결 해제
            socket.disconnect(id,data.userData.userEmail);

        };
    }, []);
    
    //방마다 허용인원 조회하기
    /////////////////////////////////////////////주소로 들어오면 토탈피플이랑 허용인원 적용 안됨.........../////////////
    ///////////소켓에서 chatroom을 만드는데 이코드가 먼저 실행되어서 데이터베이스에 있는걸 못답아 오는듯//////////////////////////
    useEffect(() => {
        const fetchAllowPeople = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/manage/chat/getAllowList/${id}`);
                if (response.status === 200) {
                    if(response.data.result==null){
                        console.log("aaaa")
                        setAllowParticipants(data.user);
                        setTotalPeople(1)
                    }else{
                        const stringArray = response.data.result.split(" "); // 공백을 기준으로 나누어 배열 생성
                        setTotalPeople(response.data.totalPeople)
                        setAllowParticipants(stringArray);
                    }
                } else {
                    throw new Error('서버 응답 오류');
                }
            } catch (error) {
                console.log(error);
                alert(error);
            }
        };
        fetchAllowPeople();
    }, []);

    //허용인원 조회한 결과로 방출입 결정
    useEffect(() => {
        if(allowParticipants[0]!=null){
                for (let i = 0; i < allowParticipants.length; i++) {
                    const element = allowParticipants[i];
                    if (data.userData.id==element) {
                        return
                    }
                }
                alert('허용되지 않은 참가자입니다.')
                const redirectURL = `/mypage`; // 리디렉션할 URL 생성
                navigate(redirectURL);
                return
        }
    }, []);

    useEffect(() => {
        const fetchpaymentData = async () => {
            try {
                    const response = await axios.get(
                        `${process.env.REACT_APP_SERVER_URL}/users/usingservice/${rightData.userEmail}`
                    );
                if (response.status === 200) {
                    setServiceData(response.data.serviceArray);
                } else {
                    throw new Error('서버 응답 오류');
                }
            } catch (error) {
                console.log(error);
                alert(error);
            }
        };
        fetchpaymentData();
    }, [rightData]);


    //채팅의 프로필이나 이름 누르면 그사람 정보 오른쪽구역에 띄우기
    const profileViewHandler = async (email) => { 
        setProfileView(true);
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/users/${email}`
                );
                if (response.status === 200) {
                    setRightData(response.data.data[0])
                } else {
                    throw new Error('서버 응답 오류');
                }
        } catch (error) {
            console.log(error);
            alert(error);
        }
    }


    const kickout = async (userEmail,userId) => { 
        socket.emit('kick', id,userEmail,userId,totalPeople);
    }

    
    //파일다운로드 눌렀을 때 원하는 파일이름으로 저장하게 하기
    const handleFileDownload = (chatFile, chatFileName) => {
        return async () => {
          try {
            const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/socket/download/${chatFile}`, {
              responseType: 'blob',
            });
            const blob = new Blob([response.data], { type: 'application/octet-stream' });
            const url = URL.createObjectURL(blob);
      
            const link = document.createElement('a');
            link.href = url;
            link.download = chatFileName; // chatFileName을 원하는 파일명으로 변경
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(url);
            document.body.removeChild(link);
          } catch (error) {
            console.error('Error downloading the file:', error);
          }
        };
      };

    const onEmojiClick = (emojiData) => {
        setchatTxt((prev) => prev + emojiData.emoji);
        setEmojiPopup(false);
    }

    const handleOutsideClick = (e) => {
        if(document.querySelector('.EmojiPickerReact') && !document.querySelector('.EmojiPickerReact').contains(e.target)){
            setEmojiPopup(false)
        }
        if (memberPopupRef.current && !memberPopupRef.current.contains(e.target)) {
            setMemberStatus(false);
        }
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormFile({ 
                file : file , 
                name : file.name , 
                size : (file.size / 1024).toFixed(2) + ' KB',
            });
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
          document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);
    










    //처음에 왔을떄 오늘날짜의 대화데이터들 불러오기
    useEffect(() => {
        const fetchMessageData = async () => {
            try {
                const formData = new FormData();
                formData.append('getDataNumber', '0');
                formData.append('userEmail', data.userData.userEmail);
                const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/socket/chat/${id}`,formData);
                if (response.status === 200) {

                   



                    if(response.data.result[0]){
                        if (response.data.result[0].chatRoom == id) {
                            for (let i = 0; i < response.data.result.length; i++) {
                            const stringArray = response.data.result[i].chatPeople.split(" "); // 공백을 기준으로 나누어 배열 생성
                                response.data.result[i].chatPeople=stringArray.length
                            }
                            setMessages(response.data.result)
                        }
                    }
                    if(getDataNumber!=0){
                        return;
                    }
                    if(response.data.message=='Y'){
                        console.log("Y")
                        setExdata(true)
                        setGetDataNumber(response.data.getDataNumber);
                    }else{
                        setExdata(false)
                    }
                } else {
                    throw new Error('서버 응답 오류');
                }
            } catch (error) {
                console.log(error);
                alert(error);
            }
        };
            fetchMessageData();
    }, [Participants]);


    useEffect(() => {
        const fetchMessageData = async () => {
            try {
                const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/manage/chat/profile/${id}`);
                if (response.status === 200) {
                    setProfile(response.data.result)
                } else {
                    throw new Error('서버 응답 오류');
                }
            } catch (error) {
                console.log(error);
                alert(error);
            }
        };
            fetchMessageData();
    }, []);
    

  


    //이전대화보기를 누를때마다 하루전날 대화내용 데이터 불러오기
    const getExChatData = async () => {
        try {
            const formData = new FormData();
            formData.append('getDataNumber', getDataNumber);
            const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/socket/chat/${id}`,formData);
            if (response.status === 200) {
                setExMessages((prevMessages) => [
                    response.data.result,
                    ...prevMessages
                ]);
                if(response.data.message=='Y'){
                    console.log(response.data.getDataNumber)
                    setExdata(true)
                    setGetDataNumber(response.data.getDataNumber);
                }else{
                    setExdata(false)
                }
            } else {
                throw new Error('서버 응답 오류');
            }
        } catch (error) {
            console.log(error);
            alert(error);
        }
    };




    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('chatTotalPeople', totalPeople);
        formData.append('chatName', data.userData.userName);
        formData.append('chatMessage', chatStatus);
        formData.append('chatEmail', data.userData.userEmail);
        formData.append('chatProfile', data.userData.userProfile);
        if(formFile){
            formData.append('chatFileName', formFile.name)
            formData.append('chatFileSize', formFile.size);
            formData.append('chatFile', formFile.file);
        };
        formData.append('chatRoom', id);
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/socket/uploadchat`,formData);
        if (response.status === 200) {
                const chatid = response.data.insertedId;
                const response2 = await axios.get(`${process.env.REACT_APP_SERVER_URL}/socket/${chatid}`);
                if (response2.status === 200) {
                    const stringArray = response2.data.result.chatPeople.split(" ");; // 공백을 기준으로 나누어 배열 생성
                    const msg = {
                        chatRoom: id,
                        chatName: response2.data.result.chatName,
                        chatEmail: response2.data.result.chatEmail,
                        chatMessage: response2.data.result.chatMessage,
                        chatFileName: response2.data.result.chatFileName,
                        chatFileSize: response2.data.result.chatFileSize,
                        chatFile: response2.data.result.chatFile,
                        chatTime: response2.data.result.chatTime,
                        chatProfile: response2.data.result.chatProfile,
                        chatPeople: stringArray.length,
                        chatTotalPeople: response2.data.result.chatTotalPeople
                    };
                    socket.emit('msg', msg);
                    setchatTxt('');
                    setFormFile(null);
                } else {
                    throw new Error('서버 응답 오류');
                }
        } else {
            throw new Error('서버 응답 오류');
        }
    };

    async function handleInviteClick(userId) {
        const formData = new FormData();
        formData.append('userId', userId);
        formData.append('id', id);
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/manage/chat/addallowpeople`,formData);
        if (response.status === 200) {
            socket.emit('invite',totalPeople,response.data.result)
        } else {
            throw new Error('서버 응답 오류');
        }
    }
      
    const [userListData, setUserListData] = useState();
    const [inviteuserListData, setInviteUserListData] = useState();

    useEffect(() => {
        const fetchUserList = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/manage/chat/userList/${id}`);
                if (response.status === 200) {
                    if(response.data.result!=undefined){
                        setUserListData(response.data.result[0]);
                    }
                    if(response.data.invite!=undefined){
                        setInviteUserListData(response.data.invite[0]);
                    }
                } else {
                    throw new Error('서버 응답 오류');
                }
            } catch (error) {
                console.log(error);
                alert(error);
            }
        };
        fetchUserList(); // Pass the 'id' value to the fetchTotalData function
    }, [totalPeople]);


    return(
        <div className="mypageContainer">
            <MypageMenu />
            <MypageContainer>
                <MyPageHeader title="채팅 서비스"/>
                    <div className={styles.chatContainer}>
                        {/* 메뉴부분입니다 */}
                        <div className={`${styles.chatList} ${(listStatus) ? styles.active : ''}`}>
                            <div className={styles.mobileListClose} onClick={listHandler}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                    <path d="M30 10L10 30" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M10 10L30 30" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <ul className={styles.chatTabBox}>
                                <li>
                                    <button className={styles.tabActive}>전체내역</button>
                                </li>
                            </ul>
                            <ul className={styles.chatListBox}>
                                <li>
                                    <div className={styles.listItem}>
                                        <div className={styles.profileBox}>
                                            <div className={styles.profileLeft}>
                                                <div className={styles.profileImg}></div>
                                                <p className={`${styles.profileName} ${styles.now}`}>
                                                    <span>
                                                        잡브 01 잡브 01 잡브 01 잡브 01 잡브 01 잡브 01 잡브 01 잡브 01 잡브 01 잡브 01 
                                                    </span>
                                                </p>
                                                {/* ⬆️ 새로운 메세지가 도착할때에는 styles.now클래스 넣어주세요. */}
                                            </div>
                                            <div className={styles.chatTime}>12분전</div>
                                            {/* 
                                                24시간동안은 1분전 ~ 2분전, 1시간전, 2시간전 이런식으로 노출하게 해주세요!
                                                24시간 이후에는 날짜 2023-00-00이렇게 나오면 될듯 합니다!! 
                                            */}
                                        </div>
                                        <div className={styles.itemTitle}>
                                            <p className={styles.i_txt}>
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                            </p>
                                            <div className={styles.new}> {/* 요거는 새로 온 채팅이 있을때만 박스를 노출해주세요!! */}
                                                3
                                            </div>
                                        </div>
                                        <div className={styles.itemText}>
                                            <p>
                                                Dooray! 파트너는 Dooray!와 함께 협력 방안을 논의하고 추진하여, 사업적 성취와 성장을 하실 수 있도록 
                                                약속드립니다.
                                            </p>
                                            <button type="button" className={`${styles.favoritesBtn} ${styles.active}`}> {/* 즐겨찾기 추가시 styles.active 클래스 넣어주세요!! */}
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2779)">
                                                        <path d="M18 21L12 17.25L6 21V4.5C6 4.30109 6.07902 4.11032 6.21967 3.96967C6.36032 3.82902 6.55109 3.75 6.75 3.75H17.25C17.4489 3.75 17.6397 3.82902 17.7803 3.96967C17.921 4.11032 18 4.30109 18 4.5V21Z" stroke="#777777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2779">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2773)">
                                                        <path d="M17.25 3H6.75C6.35218 3 5.97064 3.15804 5.68934 3.43934C5.40804 3.72064 5.25 4.10218 5.25 4.5V21C5.25007 21.1338 5.28595 21.2652 5.35393 21.3805C5.42191 21.4958 5.5195 21.5908 5.63659 21.6557C5.75367 21.7206 5.88598 21.7529 6.01978 21.7494C6.15358 21.7458 6.284 21.7066 6.3975 21.6356L12 18.1341L17.6034 21.6356C17.7169 21.7063 17.8472 21.7454 17.9809 21.7488C18.1146 21.7522 18.2467 21.7198 18.3636 21.655C18.4806 21.5902 18.5781 21.4953 18.646 21.3801C18.7139 21.2649 18.7498 21.1337 18.75 21V4.5C18.75 4.10218 18.592 3.72064 18.3107 3.43934C18.0294 3.15804 17.6478 3 17.25 3Z" fill="#FED27D"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2773">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.listItem}>
                                        <div className={styles.profileBox}>
                                            <div className={styles.profileLeft}>
                                                <div className={styles.profileImg}></div>
                                                <p className={`${styles.profileName}`}>잡브 01</p>
                                            </div>
                                            <div className={styles.chatTime}>2022-00-00</div>
                                            {/* 
                                                24시간동안은 1분전 ~ 2분전, 1시간전, 2시간전 이런식으로 노출하게 해주세요!
                                                24시간 이후에는 날짜 2023-00-00이렇게 나오면 될듯 합니다!! 
                                            */}
                                        </div>
                                        <div className={styles.itemTitle}>
                                            <p className={styles.i_txt}>
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                            </p>
                                        </div>
                                        <div className={styles.itemText}>
                                            <p>
                                                Dooray! 파트너는 Dooray!와 함께 협력 방안을 논의하고 추진하여, 사업적 성취와 성장을 하실 수 있도록 
                                                약속드립니다.
                                            </p>
                                            <button type="button" className={`${styles.favoritesBtn}`}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2779)">
                                                        <path d="M18 21L12 17.25L6 21V4.5C6 4.30109 6.07902 4.11032 6.21967 3.96967C6.36032 3.82902 6.55109 3.75 6.75 3.75H17.25C17.4489 3.75 17.6397 3.82902 17.7803 3.96967C17.921 4.11032 18 4.30109 18 4.5V21Z" stroke="#777777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2779">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2773)">
                                                        <path d="M17.25 3H6.75C6.35218 3 5.97064 3.15804 5.68934 3.43934C5.40804 3.72064 5.25 4.10218 5.25 4.5V21C5.25007 21.1338 5.28595 21.2652 5.35393 21.3805C5.42191 21.4958 5.5195 21.5908 5.63659 21.6557C5.75367 21.7206 5.88598 21.7529 6.01978 21.7494C6.15358 21.7458 6.284 21.7066 6.3975 21.6356L12 18.1341L17.6034 21.6356C17.7169 21.7063 17.8472 21.7454 17.9809 21.7488C18.1146 21.7522 18.2467 21.7198 18.3636 21.655C18.4806 21.5902 18.5781 21.4953 18.646 21.3801C18.7139 21.2649 18.7498 21.1337 18.75 21V4.5C18.75 4.10218 18.592 3.72064 18.3107 3.43934C18.0294 3.15804 17.6478 3 17.25 3Z" fill="#FED27D"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2773">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.listItem}>
                                        <div className={styles.profileBox}>
                                            <div className={styles.profileLeft}>
                                                <div className={styles.profileImg}></div>
                                                <p className={`${styles.profileName}`}>잡브 01</p>
                                            </div>
                                            <div className={styles.chatTime}>2022-00-00</div>
                                            {/* 
                                                24시간동안은 1분전 ~ 2분전, 1시간전, 2시간전 이런식으로 노출하게 해주세요!
                                                24시간 이후에는 날짜 2023-00-00이렇게 나오면 될듯 합니다!! 
                                            */}
                                        </div>
                                        <div className={styles.itemTitle}>
                                            <p className={styles.i_txt}>
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                            </p>
                                            <div className={styles.new}> {/* 요거는 새로 온 채팅이 있을때만 박스를 노출해주세요!! */}
                                                3
                                            </div>
                                        </div>
                                        <div className={styles.itemText}>
                                            <p>
                                                Dooray! 파트너는 Dooray!와 함께 협력 방안을 논의하고 추진하여, 사업적 성취와 성장을 하실 수 있도록 
                                                약속드립니다.
                                            </p>
                                            <button type="button" className={`${styles.favoritesBtn}`}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2779)">
                                                        <path d="M18 21L12 17.25L6 21V4.5C6 4.30109 6.07902 4.11032 6.21967 3.96967C6.36032 3.82902 6.55109 3.75 6.75 3.75H17.25C17.4489 3.75 17.6397 3.82902 17.7803 3.96967C17.921 4.11032 18 4.30109 18 4.5V21Z" stroke="#777777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2779">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2773)">
                                                        <path d="M17.25 3H6.75C6.35218 3 5.97064 3.15804 5.68934 3.43934C5.40804 3.72064 5.25 4.10218 5.25 4.5V21C5.25007 21.1338 5.28595 21.2652 5.35393 21.3805C5.42191 21.4958 5.5195 21.5908 5.63659 21.6557C5.75367 21.7206 5.88598 21.7529 6.01978 21.7494C6.15358 21.7458 6.284 21.7066 6.3975 21.6356L12 18.1341L17.6034 21.6356C17.7169 21.7063 17.8472 21.7454 17.9809 21.7488C18.1146 21.7522 18.2467 21.7198 18.3636 21.655C18.4806 21.5902 18.5781 21.4953 18.646 21.3801C18.7139 21.2649 18.7498 21.1337 18.75 21V4.5C18.75 4.10218 18.592 3.72064 18.3107 3.43934C18.0294 3.15804 17.6478 3 17.25 3Z" fill="#FED27D"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2773">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.listItem}>
                                        <div className={styles.profileBox}>
                                            <div className={styles.profileLeft}>
                                                <div className={styles.profileImg}></div>
                                                <p className={`${styles.profileName}`}>잡브 01</p>
                                            </div>
                                            <div className={styles.chatTime}>2022-00-00</div>
                                            {/* 
                                                24시간동안은 1분전 ~ 2분전, 1시간전, 2시간전 이런식으로 노출하게 해주세요!
                                                24시간 이후에는 날짜 2023-00-00이렇게 나오면 될듯 합니다!! 
                                            */}
                                        </div>
                                        <div className={styles.itemTitle}>
                                            <p className={styles.i_txt}>
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                            </p>
                                            <div className={styles.new}> {/* 요거는 새로 온 채팅이 있을때만 박스를 노출해주세요!! */}
                                                3
                                            </div>
                                        </div>
                                        <div className={styles.itemText}>
                                            <p>
                                                Dooray! 파트너는 Dooray!와 함께 협력 방안을 논의하고 추진하여, 사업적 성취와 성장을 하실 수 있도록 
                                                약속드립니다.
                                            </p>
                                            <button type="button" className={`${styles.favoritesBtn}`}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2779)">
                                                        <path d="M18 21L12 17.25L6 21V4.5C6 4.30109 6.07902 4.11032 6.21967 3.96967C6.36032 3.82902 6.55109 3.75 6.75 3.75H17.25C17.4489 3.75 17.6397 3.82902 17.7803 3.96967C17.921 4.11032 18 4.30109 18 4.5V21Z" stroke="#777777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2779">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2773)">
                                                        <path d="M17.25 3H6.75C6.35218 3 5.97064 3.15804 5.68934 3.43934C5.40804 3.72064 5.25 4.10218 5.25 4.5V21C5.25007 21.1338 5.28595 21.2652 5.35393 21.3805C5.42191 21.4958 5.5195 21.5908 5.63659 21.6557C5.75367 21.7206 5.88598 21.7529 6.01978 21.7494C6.15358 21.7458 6.284 21.7066 6.3975 21.6356L12 18.1341L17.6034 21.6356C17.7169 21.7063 17.8472 21.7454 17.9809 21.7488C18.1146 21.7522 18.2467 21.7198 18.3636 21.655C18.4806 21.5902 18.5781 21.4953 18.646 21.3801C18.7139 21.2649 18.7498 21.1337 18.75 21V4.5C18.75 4.10218 18.592 3.72064 18.3107 3.43934C18.0294 3.15804 17.6478 3 17.25 3Z" fill="#FED27D"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2773">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.listItem}>
                                        <div className={styles.profileBox}>
                                            <div className={styles.profileLeft}>
                                                <div className={styles.profileImg}></div>
                                                <p className={`${styles.profileName}`}>잡브 01</p>
                                            </div>
                                            <div className={styles.chatTime}>2022-00-00</div>
                                            {/* 
                                                24시간동안은 1분전 ~ 2분전, 1시간전, 2시간전 이런식으로 노출하게 해주세요!
                                                24시간 이후에는 날짜 2023-00-00이렇게 나오면 될듯 합니다!! 
                                            */}
                                        </div>
                                        <div className={styles.itemTitle}>
                                            <p className={styles.i_txt}>
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                            </p>
                                            <div className={styles.new}> {/* 요거는 새로 온 채팅이 있을때만 박스를 노출해주세요!! */}
                                                3
                                            </div>
                                        </div>
                                        <div className={styles.itemText}>
                                            <p>
                                                Dooray! 파트너는 Dooray!와 함께 협력 방안을 논의하고 추진하여, 사업적 성취와 성장을 하실 수 있도록 
                                                약속드립니다.
                                            </p>
                                            <button type="button" className={`${styles.favoritesBtn}`}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2779)">
                                                        <path d="M18 21L12 17.25L6 21V4.5C6 4.30109 6.07902 4.11032 6.21967 3.96967C6.36032 3.82902 6.55109 3.75 6.75 3.75H17.25C17.4489 3.75 17.6397 3.82902 17.7803 3.96967C17.921 4.11032 18 4.30109 18 4.5V21Z" stroke="#777777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2779">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2773)">
                                                        <path d="M17.25 3H6.75C6.35218 3 5.97064 3.15804 5.68934 3.43934C5.40804 3.72064 5.25 4.10218 5.25 4.5V21C5.25007 21.1338 5.28595 21.2652 5.35393 21.3805C5.42191 21.4958 5.5195 21.5908 5.63659 21.6557C5.75367 21.7206 5.88598 21.7529 6.01978 21.7494C6.15358 21.7458 6.284 21.7066 6.3975 21.6356L12 18.1341L17.6034 21.6356C17.7169 21.7063 17.8472 21.7454 17.9809 21.7488C18.1146 21.7522 18.2467 21.7198 18.3636 21.655C18.4806 21.5902 18.5781 21.4953 18.646 21.3801C18.7139 21.2649 18.7498 21.1337 18.75 21V4.5C18.75 4.10218 18.592 3.72064 18.3107 3.43934C18.0294 3.15804 17.6478 3 17.25 3Z" fill="#FED27D"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2773">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.listItem}>
                                        <div className={styles.profileBox}>
                                            <div className={styles.profileLeft}>
                                                <div className={styles.profileImg}></div>
                                                <p className={`${styles.profileName}`}>잡브 01</p>
                                            </div>
                                            <div className={styles.chatTime}>2022-00-00</div>
                                            {/* 
                                                24시간동안은 1분전 ~ 2분전, 1시간전, 2시간전 이런식으로 노출하게 해주세요!
                                                24시간 이후에는 날짜 2023-00-00이렇게 나오면 될듯 합니다!! 
                                            */}
                                        </div>
                                        <div className={styles.itemTitle}>
                                            <p className={styles.i_txt}>
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                            </p>
                                            <div className={styles.new}> {/* 요거는 새로 온 채팅이 있을때만 박스를 노출해주세요!! */}
                                                3
                                            </div>
                                        </div>
                                        <div className={styles.itemText}>
                                            <p>
                                                Dooray! 파트너는 Dooray!와 함께 협력 방안을 논의하고 추진하여, 사업적 성취와 성장을 하실 수 있도록 
                                                약속드립니다.
                                            </p>
                                            <button type="button" className={`${styles.favoritesBtn}`}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2779)">
                                                        <path d="M18 21L12 17.25L6 21V4.5C6 4.30109 6.07902 4.11032 6.21967 3.96967C6.36032 3.82902 6.55109 3.75 6.75 3.75H17.25C17.4489 3.75 17.6397 3.82902 17.7803 3.96967C17.921 4.11032 18 4.30109 18 4.5V21Z" stroke="#777777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2779">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2773)">
                                                        <path d="M17.25 3H6.75C6.35218 3 5.97064 3.15804 5.68934 3.43934C5.40804 3.72064 5.25 4.10218 5.25 4.5V21C5.25007 21.1338 5.28595 21.2652 5.35393 21.3805C5.42191 21.4958 5.5195 21.5908 5.63659 21.6557C5.75367 21.7206 5.88598 21.7529 6.01978 21.7494C6.15358 21.7458 6.284 21.7066 6.3975 21.6356L12 18.1341L17.6034 21.6356C17.7169 21.7063 17.8472 21.7454 17.9809 21.7488C18.1146 21.7522 18.2467 21.7198 18.3636 21.655C18.4806 21.5902 18.5781 21.4953 18.646 21.3801C18.7139 21.2649 18.7498 21.1337 18.75 21V4.5C18.75 4.10218 18.592 3.72064 18.3107 3.43934C18.0294 3.15804 17.6478 3 17.25 3Z" fill="#FED27D"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2773">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.listItem}>
                                        <div className={styles.profileBox}>
                                            <div className={styles.profileLeft}>
                                                <div className={styles.profileImg}></div>
                                                <p className={`${styles.profileName}`}>잡브 01</p>
                                            </div>
                                            <div className={styles.chatTime}>2022-00-00</div>
                                            {/* 
                                                24시간동안은 1분전 ~ 2분전, 1시간전, 2시간전 이런식으로 노출하게 해주세요!
                                                24시간 이후에는 날짜 2023-00-00이렇게 나오면 될듯 합니다!! 
                                            */}
                                        </div>
                                        <div className={styles.itemTitle}>
                                            <p className={styles.i_txt}>
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                            </p>
                                            <div className={styles.new}> {/* 요거는 새로 온 채팅이 있을때만 박스를 노출해주세요!! */}
                                                3
                                            </div>
                                        </div>
                                        <div className={styles.itemText}>
                                            <p>
                                                Dooray! 파트너는 Dooray!와 함께 협력 방안을 논의하고 추진하여, 사업적 성취와 성장을 하실 수 있도록 
                                                약속드립니다.
                                            </p>
                                            <button type="button" className={`${styles.favoritesBtn}`}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2779)">
                                                        <path d="M18 21L12 17.25L6 21V4.5C6 4.30109 6.07902 4.11032 6.21967 3.96967C6.36032 3.82902 6.55109 3.75 6.75 3.75H17.25C17.4489 3.75 17.6397 3.82902 17.7803 3.96967C17.921 4.11032 18 4.30109 18 4.5V21Z" stroke="#777777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2779">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2773)">
                                                        <path d="M17.25 3H6.75C6.35218 3 5.97064 3.15804 5.68934 3.43934C5.40804 3.72064 5.25 4.10218 5.25 4.5V21C5.25007 21.1338 5.28595 21.2652 5.35393 21.3805C5.42191 21.4958 5.5195 21.5908 5.63659 21.6557C5.75367 21.7206 5.88598 21.7529 6.01978 21.7494C6.15358 21.7458 6.284 21.7066 6.3975 21.6356L12 18.1341L17.6034 21.6356C17.7169 21.7063 17.8472 21.7454 17.9809 21.7488C18.1146 21.7522 18.2467 21.7198 18.3636 21.655C18.4806 21.5902 18.5781 21.4953 18.646 21.3801C18.7139 21.2649 18.7498 21.1337 18.75 21V4.5C18.75 4.10218 18.592 3.72064 18.3107 3.43934C18.0294 3.15804 17.6478 3 17.25 3Z" fill="#FED27D"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2773">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.listItem}>
                                        <div className={styles.profileBox}>
                                            <div className={styles.profileLeft}>
                                                <div className={styles.profileImg}></div>
                                                <p className={`${styles.profileName}`}>잡브 01</p>
                                            </div>
                                            <div className={styles.chatTime}>2022-00-00</div>
                                            {/* 
                                                24시간동안은 1분전 ~ 2분전, 1시간전, 2시간전 이런식으로 노출하게 해주세요!
                                                24시간 이후에는 날짜 2023-00-00이렇게 나오면 될듯 합니다!! 
                                            */}
                                        </div>
                                        <div className={styles.itemTitle}>
                                            <p className={styles.i_txt}>
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                            </p>
                                            <div className={styles.new}> {/* 요거는 새로 온 채팅이 있을때만 박스를 노출해주세요!! */}
                                                3
                                            </div>
                                        </div>
                                        <div className={styles.itemText}>
                                            <p>
                                                Dooray! 파트너는 Dooray!와 함께 협력 방안을 논의하고 추진하여, 사업적 성취와 성장을 하실 수 있도록 
                                                약속드립니다.
                                            </p>
                                            <button type="button" className={`${styles.favoritesBtn}`}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2779)">
                                                        <path d="M18 21L12 17.25L6 21V4.5C6 4.30109 6.07902 4.11032 6.21967 3.96967C6.36032 3.82902 6.55109 3.75 6.75 3.75H17.25C17.4489 3.75 17.6397 3.82902 17.7803 3.96967C17.921 4.11032 18 4.30109 18 4.5V21Z" stroke="#777777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2779">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2773)">
                                                        <path d="M17.25 3H6.75C6.35218 3 5.97064 3.15804 5.68934 3.43934C5.40804 3.72064 5.25 4.10218 5.25 4.5V21C5.25007 21.1338 5.28595 21.2652 5.35393 21.3805C5.42191 21.4958 5.5195 21.5908 5.63659 21.6557C5.75367 21.7206 5.88598 21.7529 6.01978 21.7494C6.15358 21.7458 6.284 21.7066 6.3975 21.6356L12 18.1341L17.6034 21.6356C17.7169 21.7063 17.8472 21.7454 17.9809 21.7488C18.1146 21.7522 18.2467 21.7198 18.3636 21.655C18.4806 21.5902 18.5781 21.4953 18.646 21.3801C18.7139 21.2649 18.7498 21.1337 18.75 21V4.5C18.75 4.10218 18.592 3.72064 18.3107 3.43934C18.0294 3.15804 17.6478 3 17.25 3Z" fill="#FED27D"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2773">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.listItem}>
                                        <div className={styles.profileBox}>
                                            <div className={styles.profileLeft}>
                                                <div className={styles.profileImg}></div>
                                                <p className={`${styles.profileName}`}>잡브 01</p>
                                            </div>
                                            <div className={styles.chatTime}>2022-00-00</div>
                                            {/* 
                                                24시간동안은 1분전 ~ 2분전, 1시간전, 2시간전 이런식으로 노출하게 해주세요!
                                                24시간 이후에는 날짜 2023-00-00이렇게 나오면 될듯 합니다!! 
                                            */}
                                        </div>
                                        <div className={styles.itemTitle}>
                                            <p className={styles.i_txt}>
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                            </p>
                                            <div className={styles.new}> {/* 요거는 새로 온 채팅이 있을때만 박스를 노출해주세요!! */}
                                                3
                                            </div>
                                        </div>
                                        <div className={styles.itemText}>
                                            <p>
                                                Dooray! 파트너는 Dooray!와 함께 협력 방안을 논의하고 추진하여, 사업적 성취와 성장을 하실 수 있도록 
                                                약속드립니다.
                                            </p>
                                            <button type="button" className={`${styles.favoritesBtn}`}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2779)">
                                                        <path d="M18 21L12 17.25L6 21V4.5C6 4.30109 6.07902 4.11032 6.21967 3.96967C6.36032 3.82902 6.55109 3.75 6.75 3.75H17.25C17.4489 3.75 17.6397 3.82902 17.7803 3.96967C17.921 4.11032 18 4.30109 18 4.5V21Z" stroke="#777777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2779">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2773)">
                                                        <path d="M17.25 3H6.75C6.35218 3 5.97064 3.15804 5.68934 3.43934C5.40804 3.72064 5.25 4.10218 5.25 4.5V21C5.25007 21.1338 5.28595 21.2652 5.35393 21.3805C5.42191 21.4958 5.5195 21.5908 5.63659 21.6557C5.75367 21.7206 5.88598 21.7529 6.01978 21.7494C6.15358 21.7458 6.284 21.7066 6.3975 21.6356L12 18.1341L17.6034 21.6356C17.7169 21.7063 17.8472 21.7454 17.9809 21.7488C18.1146 21.7522 18.2467 21.7198 18.3636 21.655C18.4806 21.5902 18.5781 21.4953 18.646 21.3801C18.7139 21.2649 18.7498 21.1337 18.75 21V4.5C18.75 4.10218 18.592 3.72064 18.3107 3.43934C18.0294 3.15804 17.6478 3 17.25 3Z" fill="#FED27D"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2773">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.listItem}>
                                        <div className={styles.profileBox}>
                                            <div className={styles.profileLeft}>
                                                <div className={styles.profileImg}></div>
                                                <p className={`${styles.profileName}`}>잡브 01</p>
                                            </div>
                                            <div className={styles.chatTime}>2022-00-00</div>
                                            {/* 
                                                24시간동안은 1분전 ~ 2분전, 1시간전, 2시간전 이런식으로 노출하게 해주세요!
                                                24시간 이후에는 날짜 2023-00-00이렇게 나오면 될듯 합니다!! 
                                            */}
                                        </div>
                                        <div className={styles.itemTitle}>
                                            <p className={styles.i_txt}>
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                                메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 메인 이미지 레퍼런스 
                                            </p>
                                            <div className={styles.new}> {/* 요거는 새로 온 채팅이 있을때만 박스를 노출해주세요!! */}
                                                3
                                            </div>
                                        </div>
                                        <div className={styles.itemText}>
                                            <p>
                                                Dooray! 파트너는 Dooray!와 함께 협력 방안을 논의하고 추진하여, 사업적 성취와 성장을 하실 수 있도록 
                                                약속드립니다.
                                            </p>
                                            <button type="button" className={`${styles.favoritesBtn}`}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2779)">
                                                        <path d="M18 21L12 17.25L6 21V4.5C6 4.30109 6.07902 4.11032 6.21967 3.96967C6.36032 3.82902 6.55109 3.75 6.75 3.75H17.25C17.4489 3.75 17.6397 3.82902 17.7803 3.96967C17.921 4.11032 18 4.30109 18 4.5V21Z" stroke="#777777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2779">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clipPath="url(#clip0_60_2773)">
                                                        <path d="M17.25 3H6.75C6.35218 3 5.97064 3.15804 5.68934 3.43934C5.40804 3.72064 5.25 4.10218 5.25 4.5V21C5.25007 21.1338 5.28595 21.2652 5.35393 21.3805C5.42191 21.4958 5.5195 21.5908 5.63659 21.6557C5.75367 21.7206 5.88598 21.7529 6.01978 21.7494C6.15358 21.7458 6.284 21.7066 6.3975 21.6356L12 18.1341L17.6034 21.6356C17.7169 21.7063 17.8472 21.7454 17.9809 21.7488C18.1146 21.7522 18.2467 21.7198 18.3636 21.655C18.4806 21.5902 18.5781 21.4953 18.646 21.3801C18.7139 21.2649 18.7498 21.1337 18.75 21V4.5C18.75 4.10218 18.592 3.72064 18.3107 3.43934C18.0294 3.15804 17.6478 3 17.25 3Z" fill="#FED27D"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_60_2773">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div> 
                        {/* 채팅 부분입니다 */}
                        <div className={styles.chatBox} >
                            <button className={styles.listBtn} onClick={listHandler}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M8.50001 12.8L14.2 18.4C14.6 18.8 15.2 18.8 15.6 18.4C16 18 16 17.4 15.6 17L10.7 12L15.6 7.00005C16 6.60005 16 6.00005 15.6 5.60005C15.4 5.40005 15.2 5.30005 14.9 5.30005C14.6 5.30005 14.4 5.40005 14.2 5.60005L8.50001 11.2C8.10001 11.7 8.10001 12.3 8.50001 12.8C8.50001 12.7 8.50001 12.7 8.50001 12.8Z" fill="#64748B"/>
                                </svg>
                            </button>
                            <ul className={styles.BubbleList}>
                                {
                                    (exdata)?
                                <li>
                                    <button type="button" className={styles.prevChatView} onClick={getExChatData} >이전 대화 기록 보기</button>
                                </li>
                                :
                                null
                                }

                                {(exMessages)?  //이전 데이터가 있으면
                                exMessages.slice(0, getDataNumber).map((msgArray, index) => (
                                    <>
                                    <li key={index}>
                                        <div className={styles.chateDateContainer}>
                                            <span>{formatDate(msgArray[index].chatTime)}</span>
                                        </div>
                                    </li>
                                    {msgArray.map((msg, msgIndex) => (
                                    <>
                                        <li>
                                                {msg.chatFile ? //파일있으면
                                                    (/\.(png|jpg|img)$/i.test(msg.chatFileName) ? //이미지파일이면
                                                        (msg.chatEmail != data.userData.userEmail) ?
                                                            <div className={styles.otherBox}>
                                                                <div className={styles.otherProfile}>
                                                                    <div className={styles.otherImg} onClick={() => profileViewHandler(msg.chatEmail)}
                                                                        style={profile ?
                                                                            profile
                                                                                .filter(profile => profile.chatEmail == msg.chatEmail)
                                                                                .map((profile) => {
                                                                                    return {
                                                                                        backgroundImage: `url(${process.env.REACT_APP_SERVER_URL}/uploads/mypage/${profile.userProfile})`
                                                                                    };
                                                                                })[0]
                                                                            :
                                                                            {}}
                                                                    ></div>
                                                                    <div className={styles.otherBubbleWrap}>
                                                                        <div className={styles.otherName} onClick={() => profileViewHandler(msg.chatEmail)}>
                                                                            {msg.chatName}
                                                                        </div>
                                                                        <div className={styles.otherBubbleBox}>
                                                                            <div className={styles.otherBubble}>
                                                                                <div className={styles.bubbleImgWrap}>
                                                                                    <img src={`${process.env.REACT_APP_SERVER_URL}/uploads/users/${msg.chatFile}`} alt="예시 이미지" />
                                                                                    <button type="button">
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                                                                            <circle cx="14" cy="14" r="13.5" fill="white" stroke="#D9D9D9" />
                                                                                            <path d="M13.6464 17.9596C13.8417 18.1549 14.1583 18.1549 14.3536 17.9596L17.5355 14.7776C17.7308 14.5824 17.7308 14.2658 17.5355 14.0705C17.3403 13.8753 17.0237 13.8753 16.8284 14.0705L14 16.899L11.1716 14.0705C10.9763 13.8753 10.6597 13.8753 10.4645 14.0705C10.2692 14.2658 10.2692 14.5824 10.4645 14.7776L13.6464 17.9596ZM13.5 7V17.6061H14.5V7H13.5Z" fill="#7F7F7F" />
                                                                                            <path d="M8.69727 16.0908V19.4999H19.3033V16.0908" stroke="#7F7F7F" />
                                                                                        </svg>
                                                                                    </button>
                                                                                </div>
                                                                                {msg.chatMessage}
                                                                            </div>
                                                                            <div className={styles.BubbleTime}>{formatDate(msg.chatTime)}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className={styles.meBox}>
                                                                <div className={styles.BubbleTime}>{formatDate(msg.chatTime)}</div>
                                                                <div className={styles.m_bubble}>
                                                                    <div className={styles.bubbleImgWrap}>
                                                                        <img src={`${process.env.REACT_APP_SERVER_URL}/uploads/users/${msg.chatFile}`} alt="예시 이미지" />
                                                                        <button type="button">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                                                                <circle cx="14" cy="14" r="13.5" fill="white" stroke="#D9D9D9" />
                                                                                <path d="M13.6464 17.9596C13.8417 18.1549 14.1583 18.1549 14.3536 17.9596L17.5355 14.7776C17.7308 14.5824 17.7308 14.2658 17.5355 14.0705C17.3403 13.8753 17.0237 13.8753 16.8284 14.0705L14 16.899L11.1716 14.0705C10.9763 13.8753 10.6597 13.8753 10.4645 14.0705C10.2692 14.2658 10.2692 14.5824 10.4645 14.7776L13.6464 17.9596ZM13.5 7V17.6061H14.5V7H13.5Z" fill="#7F7F7F" />
                                                                                <path d="M8.69727 16.0908V19.4999H19.3033V16.0908" stroke="#7F7F7F" />
                                                                            </svg>
                                                                        </button>
                                                                    </div>
                                                                    {msg.chatMessage}
                                                                </div>
                                                            </div>
                                                        :
                                                        (msg.chatEmail != data.userData.userEmail) ?
                                                            <div className={styles.otherBox}>
                                                                <div className={styles.otherProfile}>
                                                                    <div className={styles.otherImg} onClick={() => profileViewHandler(msg.chatEmail)} style={profile ?
                                                                        profile
                                                                            .filter(profile => profile.chatEmail == msg.chatEmail)
                                                                            .map((profile) => {
                                                                                return {
                                                                                    backgroundImage: `url(${process.env.REACT_APP_SERVER_URL}/uploads/mypage/${profile.userProfile})`
                                                                                };
                                                                            })[0]
                                                                        :
                                                                        {}}></div>
                                                                    <div className={styles.otherBubbleWrap}>
                                                                        <div className={styles.otherName} onClick={() => profileViewHandler(msg.chatEmail)}>
                                                                            {msg.chatName}
                                                                        </div>
                                                                        <div className={styles.otherBubbleBox}>
                                                                            <div className={styles.fileBox}>
                                                                                <div className={styles.fifleName}>
                                                                                    {msg.chatFileName}
                                                                                </div>
                                                                                <ul className={styles.fileInfo}>
                                                                                    <li>{msg.chatFileSize}</li>
                                                                                    <li>
                                                                                        <a
                                                                                            href="#"
                                                                                            onClick={handleFileDownload(msg.chatFile, msg.chatFileName)}
                                                                                        >
                                                                                            다운로드
                                                                                        </a>
                                                                                    </li>
                                                                                </ul>

                                                                            </div>
                                                                            <div className={styles.BubbleTime}>{formatDate(msg.chatTime)}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className={styles.meBox}>
                                                                <div className={styles.BubbleTime}>{formatDate(msg.chatTime)}</div>
                                                                <div className={styles.fileBox}>
                                                                    <div className={styles.fifleName}>
                                                                        {msg.chatFileName}
                                                                    </div>
                                                                    <ul className={styles.fileInfo}>
                                                                        <li>{msg.chatFileSize}</li>
                                                                        <li>
                                                                            <a
                                                                                href="#"
                                                                                onClick={handleFileDownload(msg.chatFile, msg.chatFileName)}
                                                                            >
                                                                                다운로드
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                    )
                                                    :
                                                    (msg.chatEmail != data.userData.userEmail) ?
                                                        <div className={styles.otherBox}>
                                                            <div className={styles.otherProfile}>
                                                                <div className={styles.otherImg} onClick={() => profileViewHandler(msg.chatEmail)} style={profile ?
                                                                    profile
                                                                        .filter(profile => profile.chatEmail == msg.chatEmail)
                                                                        .map((profile) => {
                                                                            return {
                                                                                backgroundImage: `url(${process.env.REACT_APP_SERVER_URL}/uploads/mypage/${profile.userProfile})`
                                                                            };
                                                                        })[0]
                                                                    :
                                                                    {}}></div>
                                                                <div className={styles.otherBubbleWrap}>
                                                                    <div className={styles.otherName} onClick={() => profileViewHandler(msg.chatEmail)}>
                                                                        {msg.chatName}
                                                                    </div>
                                                                    <div className={styles.otherBubbleBox}>
                                                                        <div className={styles.otherBubble}>
                                                                            {msg.chatMessage}
                                                                        </div>
                                                                        <div className={styles.BubbleTime}>{formatDate(msg.chatTime)}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className={styles.meBox}>
                                                            <div className={styles.BubbleTime}>{formatDate(msg.chatTime)}</div>
                                                            <div className={styles.m_bubble}>
                                                                {msg.chatMessage}
                                                            </div>
                                                        </div>}
                                            </li></>
                                    ))}

                                </>
                                ))
                                :
                                null
                                }   
                                {(messages[0])?
                                <li>
                                    <div className={styles.chateDateContainer}>
                                        <span>{formatDate(messages[0].chatTime)}</span>
                                    </div>
                                </li>
                                :
                                null
                                }
                                {
                                messages.map((msg) => (
                                <li>
                                {
                                    msg.chatFile?  //파일있으면
                                     ( /\.(png|jpg|img)$/i.test(msg.chatFileName)? //파일이 있고 이미지 파일이면
                                    (msg.chatName!=data.userData.userName) ? //파일이 있고 이미지 파일인데 나라면
                                        <div className={styles.otherBox}>
                                            <div className={styles.otherProfile}>
                                            <div className={styles.otherImg} onClick={() => profileViewHandler(msg.chatEmail)}   style={
                                                            profile? 
                                                            profile
                                                                .filter(profile => profile.chatEmail == msg.chatEmail)
                                                                .map((profile) => {
                                                                    return {
                                                                    backgroundImage: `url(${process.env.REACT_APP_SERVER_URL}/uploads/mypage/${profile.userProfile})`
                                                                    };
                                                                })[0]
                                                            : 
                                                            {}
                                                        }></div>
                                                <div className={styles.otherBubbleWrap}>
                                                    <div className={styles.otherName} onClick={() => profileViewHandler(msg.chatEmail)}>
                                                        {msg.chatName}
                                                    </div>
                                                    <div className={styles.otherBubbleBox}>
                                                        <div className={styles.otherBubble}>
                                                            <div className={styles.bubbleImgWrap}>
                                                                <img src={`${process.env.REACT_APP_SERVER_URL}/uploads/users/${msg.chatFile}`} alt="예시 이미지"/>
                                                                <button type="button" onClick={handleFileDownload(msg.chatFile, msg.chatFileName)}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                                                        <circle cx="14" cy="14" r="13.5" fill="white" stroke="#D9D9D9"/>
                                                                        <path d="M13.6464 17.9596C13.8417 18.1549 14.1583 18.1549 14.3536 17.9596L17.5355 14.7776C17.7308 14.5824 17.7308 14.2658 17.5355 14.0705C17.3403 13.8753 17.0237 13.8753 16.8284 14.0705L14 16.899L11.1716 14.0705C10.9763 13.8753 10.6597 13.8753 10.4645 14.0705C10.2692 14.2658 10.2692 14.5824 10.4645 14.7776L13.6464 17.9596ZM13.5 7V17.6061H14.5V7H13.5Z" fill="#7F7F7F"/>
                                                                        <path d="M8.69727 16.0908V19.4999H19.3033V16.0908" stroke="#7F7F7F"/>
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                            {msg.chatMessage}
                                                        </div>
                                                        <div className={styles.BubbleTime}>{formatDate(msg.chatTime)}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        //파일이 있고 이미지 파일인데 내가 아니라면
                                        <div className={styles.meBox}>
                                        <div className={styles.BubbleTime}>{formatDate(msg.chatTime)}</div>
                                            <div className={styles.m_bubble}>
                                                <div className={styles.bubbleImgWrap}>
                                                    <img src={`${process.env.REACT_APP_SERVER_URL}/uploads/users/${msg.chatFile}`} alt="예시 이미지"/>
                                                    <button type="button" onClick={handleFileDownload(msg.chatFile, msg.chatFileName)}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                                            <circle cx="14" cy="14" r="13.5" fill="white" stroke="#D9D9D9"/>
                                                            <path d="M13.6464 17.9596C13.8417 18.1549 14.1583 18.1549 14.3536 17.9596L17.5355 14.7776C17.7308 14.5824 17.7308 14.2658 17.5355 14.0705C17.3403 13.8753 17.0237 13.8753 16.8284 14.0705L14 16.899L11.1716 14.0705C10.9763 13.8753 10.6597 13.8753 10.4645 14.0705C10.2692 14.2658 10.2692 14.5824 10.4645 14.7776L13.6464 17.9596ZM13.5 7V17.6061H14.5V7H13.5Z" fill="#7F7F7F"/>
                                                            <path d="M8.69727 16.0908V19.4999H19.3033V16.0908" stroke="#7F7F7F"/>
                                                        </svg>
                                                    </button>
                                                </div>
                                                {msg.chatMessage}
                                            </div>
                                        </div>
                                    :
                                    //파일이 있고 이미지 파일이 아니고 내가아니면
                                    (msg.chatName!=data.userData.userName) ?
                                    <div className={styles.otherBox}>
                                        <div className={styles.otherProfile}>
                                        <div className={styles.otherImg} onClick={() => profileViewHandler(msg.chatEmail)}   style={
                                                            profile? 
                                                            profile
                                                                .filter(profile => profile.chatEmail == msg.chatEmail)
                                                                .map((profile) => {
                                                                    return {
                                                                    backgroundImage: `url(${process.env.REACT_APP_SERVER_URL}/uploads/mypage/${profile.userProfile})`
                                                                    };
                                                                })[0]
                                                            : 
                                                            {}
                                                        }></div>
                                            <div className={styles.otherBubbleWrap}>
                                                <div className={styles.otherName} onClick={() => profileViewHandler(msg.chatEmail)}>
                                                    {msg.chatName}
                                                </div>
                                                <div className={styles.otherBubbleBox}>
                                                    <div className={styles.fileBox}>
                                                        <div className={styles.fifleName}>
                                                            {msg.chatFileName}
                                                        </div>
                                                        <ul className={styles.fileInfo}>
                                                            <li>{msg.chatFileSize}</li>
                                                            <li>
                                                            <a
                                                            href="#"
                                                            onClick={handleFileDownload(msg.chatFile,msg.chatFileName)}
                                                            >
                                                            다운로드
                                                            </a>
                                                            </li>
                                                        </ul>

                                                    </div>
                                                    <div className={styles.BubbleTime}>{formatDate(msg.chatTime)}</div>
                                                </div>
                                            </div>
                                        </div> 
                                    </div>
                                    :
                                    //파일이 있고 이미지 파일이 아니고 나면
                                    <div className={styles.meBox}>
                                        <div className={styles.BubbleTime}>{(msg.chatPeople==msg.chatTotalPeople)? '' : msg.chatTotalPeople-msg.chatPeople}     {formatDate(msg.chatTime)}</div>
                                        <div className={styles.fileBox}>
                                            <div className={styles.fifleName}>
                                            {msg.chatFileName}
                                            </div>
                                            <ul className={styles.fileInfo}>
                                                <li>{msg.chatFileSize}</li>
                                                <li>
                                                    <a
                                                    href="#"
                                                    onClick={handleFileDownload(msg.chatFile,msg.chatFileName)}
                                                    >
                                                    다운로드
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    )
                                    :
                                    //파일이 없고 내가 아니면
                                    (msg.chatName!=data.userData.userName) ?
                                    <div className={styles.otherBox}>
                                    <div className={styles.otherProfile}> 
                                    <div className={styles.otherImg} onClick={() => profileViewHandler(msg.chatEmail)} 
                                    style={
                                        profile? 
                                        profile
                                            .filter(profile => profile.chatEmail == msg.chatEmail)
                                            .map((profile) => {
                                                return {
                                                backgroundImage: `url(${process.env.REACT_APP_SERVER_URL}/uploads/mypage/${profile.userProfile})`
                                                };
                                            })[0]
                                        : 
                                        {}
                                    }
                                    >

                                    </div>
                                    <div className={styles.otherBubbleWrap}>
                                    <div className={styles.otherName} onClick={() => profileViewHandler(msg.chatEmail)}>
                                    {msg.chatName}
                                    </div>
                                    <div className={styles.otherBubbleBox}>
                                    <div className={styles.otherBubble}>
                                    {msg.chatMessage}
                                    </div>
                                    <div className={styles.BubbleTime}>{formatDate(msg.chatTime)}    {(msg.chatPeople==msg.chatTotalPeople)? '' : msg.chatTotalPeople-msg.chatPeople}</div>
                                    </div>
                                    </div>
                                    </div>
                                    </div>
                                    :
                                    //파일이 없고 나라면
                                    //check
                                    <div className={styles.meBox}>

                                        <div className={styles.BubbleTime}>
                                            {msg.chatTotalPeople-msg.chatPeople}    {formatDate(msg.chatTime)}
                                        </div>
                                        <div className={styles.m_bubble}>
                                        {msg.chatMessage}
                                        </div>
                                    </div>
                                    }
                                </li>
                                ))
                                }  
                            </ul>
                            {/* 채팅창 입력 부분 */}
                            <div className={styles.chatEnterBox}>
                                <form onSubmit={handleSubmit}>
                                <div className={styles.chatEnterContainer}>
                                    <ul className={styles.chatMenu}>
                                        <li>
                                            <button type="button" 
                                                className={styles.emojiBtn} 
                                                onClick={EmojiPopupHandler}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M11.9667 11.8587C11.4096 12.3078 10.7156 12.5527 10 12.5527C9.28445 12.5527 8.59043 12.3078 8.03336 11.8587C7.86318 11.7172 7.64378 11.6492 7.42342 11.6695C7.20307 11.6898 6.99981 11.7968 6.85836 11.967C6.71691 12.1372 6.64886 12.3566 6.66917 12.5769C6.68949 12.7973 6.79651 13.0005 6.96669 13.142C7.81781 13.8525 8.89133 14.2417 10 14.2417C11.1087 14.2417 12.1822 13.8525 13.0334 13.142C13.2035 13.0005 13.3106 12.7973 13.3309 12.5769C13.3512 12.3566 13.2831 12.1372 13.1417 11.967C13.0717 11.8827 12.9857 11.8131 12.8887 11.762C12.7918 11.711 12.6857 11.6795 12.5766 11.6695C12.3563 11.6492 12.1369 11.7172 11.9667 11.8587ZM7.67502 8.78366C7.83116 8.93887 8.04237 9.02599 8.26252 9.02599C8.48268 9.02599 8.69389 8.93887 8.85002 8.78366C9.00523 8.62752 9.09235 8.41631 9.09235 8.19616C9.09235 7.976 9.00523 7.76479 8.85002 7.60866C8.37313 7.15615 7.74077 6.90389 7.08336 6.90389C6.42594 6.90389 5.79359 7.15615 5.31669 7.60866C5.22946 7.68337 5.15861 7.7753 5.10859 7.87868C5.05857 7.98207 5.03046 8.09468 5.02603 8.20945C5.02159 8.32421 5.04093 8.43866 5.08283 8.5456C5.12472 8.65253 5.18827 8.74966 5.26948 8.83087C5.35069 8.91208 5.44782 8.97563 5.55475 9.01752C5.66169 9.05942 5.77614 9.07876 5.8909 9.07432C6.00567 9.06989 6.11828 9.04178 6.22167 8.99176C6.32505 8.94174 6.41698 8.87089 6.49169 8.78366C6.56916 8.70555 6.66133 8.64356 6.76288 8.60125C6.86443 8.55894 6.97335 8.53716 7.08336 8.53716C7.19337 8.53716 7.30229 8.55894 7.40384 8.60125C7.50539 8.64356 7.59755 8.70555 7.67502 8.78366ZM14.6834 7.60866C14.2065 7.15615 13.5741 6.90389 12.9167 6.90389C12.2593 6.90389 11.6269 7.15615 11.15 7.60866C11.0135 7.76808 10.9422 7.97314 10.9503 8.18287C10.9584 8.3926 11.0453 8.59155 11.1937 8.73996C11.3421 8.88837 11.5411 8.97532 11.7508 8.98342C11.9605 8.99152 12.1656 8.92018 12.325 8.78366C12.4025 8.70555 12.4947 8.64356 12.5962 8.60125C12.6978 8.55894 12.8067 8.53716 12.9167 8.53716C13.0267 8.53716 13.1356 8.55894 13.2372 8.60125C13.3387 8.64356 13.4309 8.70555 13.5084 8.78366C13.6645 8.93887 13.8757 9.02599 14.0959 9.02599C14.316 9.02599 14.5272 8.93887 14.6834 8.78366C14.8386 8.62752 14.9257 8.41631 14.9257 8.19616C14.9257 7.976 14.8386 7.76479 14.6834 7.60866ZM10 1.66699C8.35185 1.66699 6.74068 2.15573 5.37027 3.07141C3.99986 3.98709 2.93176 5.28858 2.30103 6.8113C1.6703 8.33401 1.50527 10.0096 1.82681 11.6261C2.14836 13.2426 2.94203 14.7274 4.10747 15.8929C5.27291 17.0583 6.75776 17.852 8.37427 18.1735C9.99078 18.4951 11.6663 18.3301 13.1891 17.6993C14.7118 17.0686 16.0133 16.0005 16.9289 14.6301C17.8446 13.2597 18.3334 11.6485 18.3334 10.0003C18.3334 8.90598 18.1178 7.82234 17.699 6.8113C17.2802 5.80025 16.6664 4.88159 15.8926 4.10777C15.1188 3.33395 14.2001 2.72012 13.1891 2.30133C12.178 1.88254 11.0944 1.66699 10 1.66699ZM10 16.667C8.68148 16.667 7.39255 16.276 6.29622 15.5435C5.19989 14.8109 4.34541 13.7697 3.84083 12.5515C3.33624 11.3334 3.20422 9.99293 3.46146 8.69972C3.71869 7.40652 4.35363 6.21863 5.28598 5.28628C6.21833 4.35393 7.40622 3.71899 8.69942 3.46176C9.99263 3.20452 11.3331 3.33654 12.5512 3.84113C13.7694 4.34571 14.8106 5.2002 15.5432 6.29652C16.2757 7.39285 16.6667 8.68178 16.6667 10.0003C16.6667 11.7684 15.9643 13.4641 14.7141 14.7144C13.4638 15.9646 11.7681 16.667 10 16.667Z" fill="#7F7F7F"/>
                                                </svg>
                                            </button>
                                            {(emojiPopup) ? 
                                                <EmojiPicker 
                                                    onEmojiClick = {onEmojiClick}
                                                    style={{position:"absolute",}}
                                                   
                                                /> 
                                                : 
                                                null
                                            }
                                        </li>
                                        <li>
                                            <label htmlFor="chatFile" className={styles.fileAddBtn}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M15.8334 4.58303H10.6L10.3334 3.74969C10.1605 3.26072 9.83981 2.83761 9.41577 2.53899C8.99173 2.24038 8.48532 2.08103 7.96669 2.08303H4.16669C3.50365 2.08303 2.86776 2.34642 2.39892 2.81526C1.93008 3.2841 1.66669 3.91999 1.66669 4.58303V15.4164C1.66669 16.0794 1.93008 16.7153 2.39892 17.1841C2.86776 17.653 3.50365 17.9164 4.16669 17.9164H15.8334C16.4964 17.9164 17.1323 17.653 17.6011 17.1841C18.07 16.7153 18.3334 16.0794 18.3334 15.4164V7.08303C18.3334 6.41999 18.07 5.7841 17.6011 5.31526C17.1323 4.84642 16.4964 4.58303 15.8334 4.58303ZM16.6667 15.4164C16.6667 15.6374 16.5789 15.8493 16.4226 16.0056C16.2663 16.1619 16.0544 16.2497 15.8334 16.2497H4.16669C3.94567 16.2497 3.73371 16.1619 3.57743 16.0056C3.42115 15.8493 3.33335 15.6374 3.33335 15.4164V4.58303C3.33335 4.36201 3.42115 4.15005 3.57743 3.99377C3.73371 3.83749 3.94567 3.74969 4.16669 3.74969H7.96669C8.14139 3.74924 8.31182 3.80371 8.45388 3.90539C8.59594 4.00708 8.70245 4.15084 8.75835 4.31636L9.20835 5.68303C9.26426 5.84854 9.37077 5.99231 9.51283 6.09399C9.65489 6.19568 9.82532 6.25014 10 6.24969H15.8334C16.0544 6.24969 16.2663 6.33749 16.4226 6.49377C16.5789 6.65005 16.6667 6.86201 16.6667 7.08303V15.4164Z" fill="#7F7F7F"/>
                                                </svg>
                                            </label>
                                            <input type="file" id="chatFile" onChange={handleFileChange}/>
                                        </li>
                                    </ul>
                                    {(formFile) ? 
                                        <div className={styles.submitFileBox}>
                                            <div className={styles.fileContainer}>
                                                <div className={styles.s_file_info}>
                                                    <p className={styles.s_fileName}>{formFile.name}</p>
                                                    <p className={styles.fileSize}>{formFile.size}</p>
                                                </div>
                                                <button 
                                                    className={styles.fileDel}
                                                    onClick={() => setFormFile()} 
                                                >
                                                    X
                                                </button>
                                            </div>
                                        </div>
                                        :
                                        null
                                    }
                                    <textarea 
                                        placeholder="메세지를 입력하세요."
                                        value={chatStatus}
                                        onChange={chatHandler}
                                    ></textarea>
                                    <ul className={styles.chatMenu2}>
                                        <li><button type="button" className={styles.memberBtn} onClick={memberPopupHandler}>참여자 확인</button></li>
                                        <li>전체 인원 : {totalPeople}       현재 인원 : {(Participants)?Participants.length:null}</li>
                                            {/* 참여자 확인은 관리자 계정에만 노출됩니다 최고관리자에게만 li 자식 버튼을 노출해주세요!!  */}
                                        <li><button type="submit" className={styles.chatSubmitBtn}>전송</button></li>
                                      
                                    </ul>
                                </div>
                                </form>
                            </div>
                        </div>  
                        {/* 프로필 부분 입니다.*/}
                        <div className={`${styles.individualBox} ${(profileView) ? styles.active : '' }`}>
                            <button type="button" className={styles.mo_profileBtn} onClick={profileViewHideHandler}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                    <path d="M24 8L8 24" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M8 8L24 24" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                            <div className={styles.indi_profileBox}>
                                <div className={styles.indiProfile} style={{ backgroundImage: rightData.userProfile!=null ? `url(${process.env.REACT_APP_SERVER_URL}/uploads/mypage/${rightData.userProfile})`:"" }}>
                                </div>
                                <div className={styles.indiContent}>
                                    <p className={styles.indiName}>{rightData.userName}<span>{rightData.userGrade}</span></p>
                                    <p className={styles.indiCompany}>{rightData.userCompany}</p>
                                </div>
                            </div>
                            <div className={styles.clientInfo}>
                                <h2>클라이언트 정보</h2>
                                <div className={styles.clientItem}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M19.4396 13.0004C19.2196 13.0004 18.9896 12.9304 18.7696 12.8804C18.3241 12.7822 17.8863 12.6518 17.4596 12.4904C16.9957 12.3216 16.4858 12.3304 16.0279 12.515C15.5701 12.6996 15.1967 13.047 14.9796 13.4904L14.7596 13.9404C13.7856 13.3985 12.8906 12.7256 12.0996 11.9404C11.3144 11.1494 10.6414 10.2544 10.0996 9.28036L10.5196 9.00036C10.963 8.78327 11.3104 8.40989 11.495 7.95205C11.6796 7.49421 11.6884 6.98427 11.5196 6.52036C11.3608 6.09278 11.2305 5.65515 11.1296 5.21036C11.0796 4.99036 11.0396 4.76036 11.0096 4.53036C10.8882 3.82598 10.5192 3.1881 9.96923 2.7316C9.41923 2.27509 8.72431 2.02997 8.00961 2.04036H5.00961C4.57864 2.03631 4.15186 2.12517 3.75832 2.30089C3.36478 2.4766 3.01372 2.73505 2.72904 3.05864C2.44436 3.38222 2.23275 3.76335 2.1086 4.17607C1.98445 4.58879 1.95069 5.02342 2.00961 5.45036C2.54235 9.63974 4.45564 13.5322 7.44726 16.513C10.4389 19.4938 14.3383 21.3929 18.5296 21.9104H18.9096C19.647 21.9114 20.359 21.6409 20.9096 21.1504C21.226 20.8674 21.4787 20.5205 21.6511 20.1327C21.8235 19.7448 21.9116 19.3248 21.9096 18.9004V15.9004C21.8974 15.2057 21.6444 14.5369 21.194 14.008C20.7435 13.4791 20.1234 13.123 19.4396 13.0004ZM19.9396 19.0004C19.9394 19.1423 19.909 19.2827 19.8504 19.412C19.7918 19.5413 19.7063 19.6566 19.5996 19.7504C19.4879 19.8468 19.3572 19.9189 19.216 19.962C19.0748 20.005 18.9262 20.0181 18.7796 20.0004C15.0345 19.5202 11.5558 17.8068 8.89233 15.1306C6.22881 12.4545 4.53202 8.96769 4.06961 5.22036C4.0537 5.07387 4.06765 4.92569 4.11061 4.78475C4.15358 4.64381 4.22468 4.51304 4.31961 4.40036C4.41332 4.29369 4.52867 4.2082 4.65799 4.14957C4.78731 4.09095 4.92763 4.06054 5.06961 4.06036H8.06961C8.30216 4.05518 8.52924 4.13124 8.71176 4.27543C8.89428 4.41962 9.02082 4.62293 9.06961 4.85036C9.10961 5.12369 9.15961 5.39369 9.21961 5.66036C9.33513 6.1875 9.48887 6.70554 9.67961 7.21036L8.27961 7.86036C8.15991 7.91528 8.05223 7.9933 7.96277 8.08995C7.87331 8.1866 7.80381 8.29997 7.75828 8.42355C7.71275 8.54713 7.69208 8.67849 7.69746 8.81008C7.70284 8.94167 7.73415 9.0709 7.78961 9.19036C9.22881 12.2731 11.7069 14.7512 14.7896 16.1904C15.0331 16.2904 15.3062 16.2904 15.5496 16.1904C15.6743 16.1457 15.7889 16.0768 15.8868 15.9875C15.9846 15.8983 16.0638 15.7905 16.1196 15.6704L16.7396 14.2704C17.2566 14.4552 17.7842 14.6088 18.3196 14.7304C18.5863 14.7904 18.8563 14.8404 19.1296 14.8804C19.357 14.9291 19.5604 15.0557 19.7045 15.2382C19.8487 15.4207 19.9248 15.6478 19.9196 15.8804L19.9396 19.0004Z" fill="#64748B"/>
                                    </svg>
                                    <p>
                                        {formattedPhone}
                                    </p>
                                </div>
                                <div className={styles.clientItem}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M19 4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7V17C2 17.7956 2.31607 18.5587 2.87868 19.1213C3.44129 19.6839 4.20435 20 5 20H19C19.7956 20 20.5587 19.6839 21.1213 19.1213C21.6839 18.5587 22 17.7956 22 17V7C22 6.20435 21.6839 5.44129 21.1213 4.87868C20.5587 4.31607 19.7956 4 19 4ZM18.59 6L12.71 11.88C12.617 11.9737 12.5064 12.0481 12.3846 12.0989C12.2627 12.1497 12.132 12.1758 12 12.1758C11.868 12.1758 11.7373 12.1497 11.6154 12.0989C11.4936 12.0481 11.383 11.9737 11.29 11.88L5.41 6H18.59ZM20 17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H5C4.73478 18 4.48043 17.8946 4.29289 17.7071C4.10536 17.5196 4 17.2652 4 17V7.41L9.88 13.29C10.4425 13.8518 11.205 14.1674 12 14.1674C12.795 14.1674 13.5575 13.8518 14.12 13.29L20 7.41V17Z" fill="#64748B"/>
                                    </svg>
                                    <p>{rightData.userEmail}</p>
                                </div>
                            </div>
                            <div className={styles.serviceBox}>
                                <h2>이용중인 서비스</h2>
                                <ul className={styles.serviceList}>
                                {   
                                (serviceData) ? 
                                serviceData.map((service) => (
                                    <li>
                                        {service=='사이트 유지보수' && (
                                            <div style={{ backgroundColor: "#9FC3E7" }}>{service}</div>
                                        )}
                                        {service!='사이트 유지보수'&& <div>{service}</div>}
                                    </li>
                                ))
                                : null
                                }
                                </ul>
                            </div>
                            <div className={styles.priceBox}>
                                <h2>결제 정보</h2>
                                <ul className={styles.priceInfo}>
                                    <li>
                                        <label>베이직 플랜</label>
                                        <div>1,000,000원</div>
                                    </li>
                                    <li>
                                        <label>유지보수 요금</label>
                                        <div>200,000원</div>
                                    </li>
                                    <li>
                                        <label>신규 할인</label>
                                        <div style={{color:"#E17875"}}>-50,000</div>
                                    </li>
                                    <li className={styles.totalPrice}>
                                        <label>총 합계 <span>결제완료건</span></label>
                                        <div>1,150,000원</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
            </MypageContainer>

            {/* 최고관리자만 노출되는 팝업창입니다. */}
            <div className={`${styles.mbPopupContainer} ${memberStatus ? styles.active : ''}`}>
                <div className={styles.popupContent} ref={memberPopupRef}>
                    <h3>채팅방 참여자</h3>
                    <div className={styles.searchBox}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M8.25 3C5.3505 3 3 5.3505 3 8.25C3 11.1495 5.3505 13.5 8.25 13.5C11.1495 13.5 13.5 11.1495 13.5 8.25C13.5 5.3505 11.1495 3 8.25 3ZM1.5 8.25C1.5 4.52208 4.52208 1.5 8.25 1.5C11.9779 1.5 15 4.52208 15 8.25C15 11.9779 11.9779 15 8.25 15C4.52208 15 1.5 11.9779 1.5 8.25Z" fill="#64748B"/>
                            <path fillRule="evenodd" clipRule="evenodd" d="M11.9572 11.957C12.2501 11.6641 12.725 11.6641 13.0179 11.957L16.2804 15.2195C16.5733 15.5124 16.5733 15.9872 16.2804 16.2801C15.9875 16.573 15.5126 16.573 15.2197 16.2801L11.9572 13.0176C11.6643 12.7247 11.6643 12.2499 11.9572 11.957Z" fill="#64748B"/>
                        </svg>
                        <input type="text" className={styles.search_ipt} placeholder="검색어를 입력하세요."/>

                    </div>
                    <ul className={styles.memberList}>
                    {(inviteuserListData) ? 
                            inviteuserListData
                            .sort((a, b) => (a.userAdmin - b.userAdmin))
                            .map((user) => (
                                <li>
                                {(data.userData.userAdmin==1)?
                                <>
                                <div className={styles.mbWrap}>
                                    <div className={styles.mbprofile} style={{ backgroundImage: user.userProfile!=null ? `url(${process.env.REACT_APP_SERVER_URL}/uploads/mypage/${user.userProfile})`:"" }}></div>
                                    <div className={styles.mb_name}>
                                        <p>{user.userCompany} - {user.userName}</p>
                                        <p>{user.userGrade}</p>
                                    </div>
                                </div>
                                {
                                (data.userData.userEmail!=user.userEmail)?
                                <>
                            {(Participants) ?
                                Participants.map((participant) => (
                                    (participant.id === user.id) ? (
                                    <div key={participant.id} style={{ marginTop: '20px' }}>
                                        <img src={`${process.env.REACT_APP_SERVER_URL}/uploads/mypage/userProfile-1692693965316-2365725.png`} alt="예시 이미지" width="10" height="10" />
                                    </div>
                                    ) : null
                                )) : null}
                                <button type="button" className={styles.mbBanBtn} onClick={() => kickout(user.userEmail, user.id)}>강퇴</button>
                                </>
                                :
                                null
                                }
                                </>
                                :
                                <div className={styles.mbWrap}>
                                <div className={styles.mbprofile} style={{ backgroundImage: user.userProfile!=null ? `url(${process.env.REACT_APP_SERVER_URL}/uploads/mypage/${user.userProfile})`:"" }}></div>
                                <div className={styles.mb_name}>
                                    <p>{user.userCompany} - {user.userName}</p>
                                    <p>{user.userGrade}</p>
                                </div>
                                </div>
                                }
                                </li>
                            ))
                            :
                            null
                    }
                    {/* {(Participants) ? 
                            Participants.map((user) => (
                                <li>
                                {(data.userData.userAdmin==1)?
                                <>
                                <div className={styles.mbWrap}>
                                    <div className={styles.mbprofile} style={{ backgroundImage: user.userProfile!=null ? `url(${process.env.REACT_APP_SERVER_URL}/uploads/mypage/${user.userProfile})`:"" }}></div>
                                    <div className={styles.mb_name}>
                                        <p>{user.userCompany} - {user.userName}</p>
                                        <p>{user.userGrade}</p>
                                    </div>
                                </div>
                                {(data.userData.userEmail!=user.userEmail)?
                                <button type="button" className={styles.mbBanBtn} onClick={() => kickout(user.userEmail,user.id)}>강퇴</button>
                                :
                                null
                                }
                                </>
                                :
                                <div className={styles.mbWrap}>
                                <div className={styles.mbprofile} style={{ backgroundImage: user.userProfile!=null ? `url(${process.env.REACT_APP_SERVER_URL}/uploads/mypage/${user.userProfile})`:"" }}></div>
                                <div className={styles.mb_name}>
                                    <p>{user.userCompany} - {user.userName}</p>
                                    <p>{user.userGrade}</p>
                                </div>
                                </div>
                                }
                                </li>
                            ))
                            :
                            null
                    } */}
                        { (userListData) ? 
                            userListData.map((user) => (
                                <li>
                                <div className={styles.mbWrap}>
                                    <div className={styles.mbprofile}></div>
                                    <div className={styles.mb_name}>
                                        <p>{user.userName}</p>
                                        <p>{user.userCompany} {user.userGrade}</p>
                                    </div>
                                </div>
                                <button type="button" className={styles.mbBtn}  onClick={() => handleInviteClick(user.id)}>초대</button>
                            </li>
                            ))
                            : null
                            }          
                    </ul>
                    <button type="button" onClick={memberPopupHandler} className={styles.mbCloseBtn}>닫기</button>
                </div>
            </div>
        </div>
    )
}

export default MypageChat; 